import { useEffect, useRef, useState } from 'react';

import {
    isSessionStorageAvailable,
    safeGetSessionStorageItem,
    safeSetSessionStorageItem,
} from '@telialt/utils/src/sessionStorage';

import { HEADER_EXPANDED_STATE_KEY } from '../constants';

const getStoredExpandState = () => {
    if (typeof window === 'undefined' || !isSessionStorageAvailable()) {
        return undefined;
    }
    const stored = safeGetSessionStorageItem(HEADER_EXPANDED_STATE_KEY);

    return stored ? stored === 'true' : undefined;
};

const setStoredExpandState = (value: boolean) => {
    if (typeof window !== 'undefined') {
        safeSetSessionStorageItem(HEADER_EXPANDED_STATE_KEY, String(value));
    }
};

export const useHeaderExpandedState = (enabled: boolean, isDefaultExpanded: boolean, isForceExpanded?: boolean) => {
    const init = isForceExpanded || (getStoredExpandState() ?? isDefaultExpanded);
    const [isHeaderExpanded, setIsHeaderExpanded] = useState(init);

    const previousIsForceExpanded = useRef<typeof isForceExpanded>(null);
    useEffect(() => {
        if (typeof isForceExpanded === 'boolean' && previousIsForceExpanded.current != null) {
            setIsHeaderExpanded(isForceExpanded);
        }
        previousIsForceExpanded.current = isForceExpanded;
    }, [isForceExpanded]);

    if (!enabled) {
        return { isHeaderExpanded: undefined, toggleHeaderExpand: undefined } as const;
    }

    const toggleHeaderExpand = () => {
        setIsHeaderExpanded((prev) => {
            const next = !prev;
            if (isForceExpanded !== true) {
                setStoredExpandState(next);
            }

            return next;
        });
    };

    return { isHeaderExpanded, toggleHeaderExpand } as const;
};
